import "./ProfPage.css";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import {
  InputGroup,
  Container,
  Row,
  Form,
  Button,
  Offcanvas,
} from "react-bootstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { registerUser } from "../../../Auth/authServices";
import { ToastContainer, toast } from "react-toastify";
import { doc, setDoc, Timestamp } from "firebase/firestore";
import { db } from "../../../../Firebase";

function ProfPage() {
  const [show, setShow] = useState(false);
  const user_id = sessionStorage.getItem("user_id");

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const onSubmit = (data) => {
    const { nom, prenom, email, domaine } = data;
    const password = "123456";
    registerUser(email, password)
      .then((userCredential) => {
        const user = userCredential.user;
        setDoc(doc(db, "users", user.uid), {
          ...data,
          user_type: "prof",
          isArchived: false,
          admin_id: user_id,
          registeredAt: Timestamp.fromDate(new Date()),
        });
        reset();
        handleClose();
        toast.success("Prof ajouté avec succès!");
      })
      .catch((error) => {
        toast.warning("erreur!");
        const errorCode = error.code;
        console.log(errorCode);
      });
  };

  return (
    <div className="prof-page">
      <Container fluid>
        <Row>
          <div className="d-flex justify-content-between align-items-center">
            <InputGroup className="mb-2 w-75">
              <InputGroup.Text className="">
                <AiOutlineSearch />
              </InputGroup.Text>
              <Form.Control
                placeholder="Search"
                type="search"
                aria-label="Search"
                className="inp1"
              />
            </InputGroup>
            <Button variant="primary" onClick={handleShow}>
              Ajout Professeur
            </Button>
            <Offcanvas show={show} onHide={handleClose} placement="end">
              <Offcanvas.Header closeButton>
                <Offcanvas.Title className="text-uppercase">
                  Ajouter un prof
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
              <Form onSubmit={handleSubmit(onSubmit)}>
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Prénom</Form.Label>
                    <Form.Control
                      {...register("prenom")}
                      type="text"
                      placeholder="Kalika"
                    />
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Nom</Form.Label>
                    <Form.Control
                      {...register("nom")}
                      type="text"
                      placeholder="BA"
                    />
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Résidence</Form.Label>
                    <Form.Control
                      {...register("residence")}
                      type="text"
                      placeholder="HLM Grand yoff..."
                    />
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Email address</Form.Label>
                    <Form.Control
                      {...register("email")}
                      type="email"
                      placeholder="exemple@xyz.com"
                    />
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Domaine</Form.Label>
                    <Form.Select {...register("domaine")}>
                      <option value="programmation">Programmation</option>
                      <option value="Design">Design</option>
                      <option value="Marketing Digital">
                        Marketing Digital
                      </option>
                      <option value="Gestion de projet">
                        Gestion de projet
                      </option>
                    </Form.Select>
                  </Form.Group>
                  <Button  type="reset" onClick={handleClose} variant="danger">
                    Annuler
                  </Button>
                  <Button variant="success" type="submit">
                    Valider
                  </Button>
                </Form>
              </Offcanvas.Body>
            </Offcanvas>
          </div>
        </Row>
      </Container>
    </div>
  );
}

export default ProfPage;
